export default function () {
  var data = sessionStorage.getItem('ipgeo');
  if (!data) {
    return false;
  }

  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve(JSON.parse(atob(data)));
    }, 250);
  });
}
